import { Component } from "react";
import ReactDOM from 'react-dom';
import logo from '../img/app-icon-without-background.png';
import DualBallSpinner from '../img/dual-ball-1s-100px.gif'
import ShowHelp from '../img/help-icon.png';
import HideHelp from '../img/help-close-icon.png';
import { cssFormInput, cssFormInputLabel, cssFormInputText, cssFormInputButton, cssError, textField, passwordField, postMethod, httpOKsuccess, numberField, emailAlreadyInUseHeader, passwordIssueHeader, emailRegularExpression} from "./Library";
import validator from 'validator'

const emailField = "email";
const passwordFieldId = "password";
const repeatPasswordField = "repeatPassword";
const firstNameField = "firstName";
const lastNameField = "lastName";

const divForFeedbackMessage = "responseMessageId";

export class Register extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            helpVisible: false,
            email: '',
            password: '',
            repeatPassword: '',
            firstName: '',
            lastName: '',
            errorFirstName: '',
            errorLastName: '',
            errorEmail: '',
            errorPassword: ''
        }
    }
    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.type === numberField ? parseInt(target.value) : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleRegister = async (e) => {
        e.preventDefault();
        const isValid = this.handleValidation();

        if (isValid) {
            this.setState({ loading: true });

            const registerUserResponse = await fetch(process.env.REACT_APP_API_ENDPOINT + "user/" + this.state.email + "/" + this.state.firstName + "/" + this.state.lastName + "/" + this.state.password, { method: postMethod });

            var responseLabel = document.getElementById(divForFeedbackMessage);
            if (registerUserResponse.status == httpOKsuccess) {
                ReactDOM.render(<label className={cssFormInputLabel}>You have been succesfully registered. Your business administrator will now need to add you to the business before you can access the system.</label>, responseLabel);
            } else {
                var failureReason;
                if (registerUserResponse.headers.has(passwordIssueHeader)) {
                    failureReason = registerUserResponse.headers.get(passwordIssueHeader);
                }
                if (registerUserResponse.headers.has(emailAlreadyInUseHeader)) {
                    failureReason = <>The email address is already in use. If needed, please use our <a href='forgotpassword'>forgotten password link</a>  to recover your password.</>;
                }
                ReactDOM.render(<p className={cssError}>{failureReason}</p>, responseLabel);
            }
            this.setState({ loading: false });
        }
    }

    handleValidation() {
        let validated = true;
        const passwordErrors = [];

        if (this.state.firstName.length == 0) {
            this.setState({ errorFirstName: "You must include your first name." });
            validated = false;
        } else {
            this.setState({ errorFirstName: "" });
        }

        if (this.state.lastName.length == 0) {
            this.setState({ errorLastName: "You must include your last name." });
            validated = false;
        } else {
            this.setState({ errorLastName: "" });
        }

        if (this.state.email.length == 0) {
            this.setState({ errorEmail: "You must include your email address." });
            validated = false;
        } else {
            if (emailRegularExpression.test(this.state.email)) {
                this.setState({ errorEmail: "Email address is not formatted correctly"})
            }
            this.setState({ errorEmail: "" });
        }

        if (this.state.password == "") {
            validated = false;
            passwordErrors.push("You must enter your password");
        }

        if (this.state.repeatPassword == "") {
            validated = false;
            passwordErrors.push("You must enter the password confirmation");
        } 

        if (this.state.password != this.state.repeatPassword) {
            validated = false;
            passwordErrors.push("Passwords must match");
        } 

        if (!validator.isStrongPassword(this.state.password, { minLength: 8, minLowercase: 1, minUppercase: 1, minNumbers: 1, minSymbols: 1 })) {
            validated = false;
            passwordErrors.push("Password must be eight characters in length, and contain a lowercase, uppercase, number and a symbol");
        } 

        this.setState({ errorPassword: passwordErrors.map(passwordError => <li>{passwordError}</li>) });
        
        return validated;
    }

    toggleHelp = (event) => {
        this.setState({
            helpVisible: !this.state.helpVisible
        });
    }
    render() {
        return <><header>
            <ul className="navbar-nav flex-grow">
                <img className="logo" src={logo} alt="Receipts and Rewards Logo" width="58px" height="58px" /><div> Receipts  and Rewards </div></ul>
        </header>
            <div>
                <form onSubmit={this.handleRegister} className={cssFormInput}>
                    <label className={cssFormInputLabel} for={emailField } >Email</label>
                    <input className={cssFormInputText} type={textField} name={emailField} id={emailField} onChange={this.handleInputChange} />{this.state.errorEmail && <p className={cssError}>{this.state.errorEmail}</p>}
                    <label className={cssFormInputLabel} for={firstNameField}>First Name</label>
                    <input className={cssFormInputText} type={textField} name={firstNameField} id={firstNameField} onChange={this.handleInputChange} />{this.state.errorFirstName && <p className={cssError}>{this.state.errorFirstName}</p>}
                    <label className={cssFormInputLabel} for={lastNameField}>Last Name</label>
                    <input className={cssFormInputText} type={textField} name={lastNameField} id={lastNameField} onChange={this.handleInputChange} />{this.state.errorLastName && <p className={cssError}>{this.state.errorLastName}</p>}
                    <label className={cssFormInputLabel} for={passwordFieldId}>Password</label>
                    <input className={cssFormInputText} type={passwordField} name={passwordFieldId} id={passwordFieldId} onChange={this.handleInputChange} />{this.state.errorPassword && <p className={cssError}>{this.state.errorPassword}</p>}
                    <label className={cssFormInputLabel} for={repeatPasswordField}>Repeat Password</label>
                    <input className={cssFormInputText} type={passwordField} name={repeatPasswordField} id={repeatPasswordField} onChange={this.handleInputChange} />
                    <input type="submit" className={cssFormInputButton} value="Register" disabled={this.state.submitButtonDisabled} />
                    <img src={this.state.helpVisible ? HideHelp : ShowHelp} className="btn-help" onClick={this.toggleHelp} />
                </form><p id="help" className={"collapse" + (this.state.helpVisible ? ".in" : "")}>
                    You can register for a Receipts and Rewards account here. You will need to enter your email address, First Name, Last Name and a password that is... . Once registered, your business administrator will need to add you to the business so that you can use the system.</p>
                {this.state.loading ? <img src={DualBallSpinner} alt="Loading" /> : ''}
                <div id={divForFeedbackMessage }/>
            </div>
        </>
    }
}